<script lang="ts">
    import {getSanitize} from 'src/core';

    export let content: any; // TODO: record.exports is not typed yet, replace with actual type when done
    export let customClass = '';
    export let customWhitespaceHtmlFiltering = false;

    const sanitizeHtml = getSanitize();

    // Utility to convert HTML string into nodes
    function htmlToNodes(html: string) {
        const template = document.createElement('template');
        template.innerHTML = html;
        return template.content.childNodes;
    }

    // Utility to check if a node contains meaningful content
    function isNonEmptyNode(node: Node): boolean {
        if (node.nodeType === Node.TEXT_NODE) {
            // Check if text node has non-whitespace content
            return node.textContent?.trim().length > 0;
        } else if (node.nodeType === Node.ELEMENT_NODE) {
            // Check if the element or its descendants contain any content
            const element = node as Element;
            return Array.from(element.childNodes).some(isNonEmptyNode);
        }

        return false;
    }

    // Gets valid HTML without white spaces, so :empty CSS selector can be applied
    function getValidHtml() {
        const sanitizedContent = sanitizeHtml(content);
        const nodes = htmlToNodes(sanitizedContent);
        const template = document.createElement('div');

        nodes.forEach((node) => {
            if (isNonEmptyNode(node)) {
                template.appendChild(node);
            }
        });

        return template.innerHTML;
    }
</script>

<div class="paragraph-template {customClass}">
    {#if customWhitespaceHtmlFiltering}
        {@html getValidHtml()}
    {:else}
        {@html sanitizeHtml(content)}
    {/if}
</div>

<style lang="less">
    .paragraph-template:empty {
        display: none;
    }
</style>